import React, { useEffect } from "react";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { loginSchema } from "../../../helpers/yup_validator";
import { post } from "../../../helpers/api_helper";
import styles from "../../../layout/Auth/Authcss.module.scss";
import gmail from "../../../Assets/svg/login/gmail.svg";
import pwd from "../../../Assets/svg/login/password.svg";
import visiblePass from "../../../Assets/svg/login/visible-pass.svg";
import nonVisiblePass from "../../../Assets/svg/login/non-visible-pass.svg";
import { loginFailure, loginSuccess } from "../../../store/login";
import { ROUTES } from "../..";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      showPassword: false,
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting, setErrors, setStatus }) => {
      try {
        const loginData = {
          email: values.email,
          password: values.password,
        };

        const response = await post("/user/admin/login", loginData);

        if (response.success) {
          dispatch(
            loginSuccess({
              token: response?.data?.token,
              userData: response?.data?.userDetail,
            })
          );
          navigate("/dashboard");
        } else {
          setStatus({
            server: response.message || "Login failed. Please try again.",
          });
          dispatch(
            loginFailure(response.message || "Login failed. Please try again.")
          );
        }
      } catch (error) {
        console.log(error);
        if (error.response) {
          const { status, data } = error.response;
          if (status === 400) {
            setErrors({
              email: data.email || "",
              password:
                data.password || "Invalid email or password. Please try again.",
            });
          } else {
            setStatus({
              server: data.message || "Server error. Please try again later.",
            });
          }
        } else {
          setStatus({ server: "Network error. Please check your connection." });
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <div className={`${styles.formInner} formInner`}>
      <div className={`${styles.top} top py-2 text-center`}>
        <h2 className="m-0 fw-sbold head">Welcome Back !</h2>
        <p className="m-0 py-1">Please enter your details</p>
      </div>
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col lg="12" className="my-3">
            <div className="FormHeading">
              <h4 className="m-0 fw-sbold">Login</h4>
              <p className="m-0">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis{" "}
              </p>
            </div>
          </Col>
          <Col lg="12" className="my-3">
            <div className="position-relative labelInput">
              <div className="iconWithText position-relative">
                <input
                  type="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-control "
                  placeholder="abc@gmail.com"
                />
                <span className="icn position-absolute" style={{ left: "8px" }}>
                  <img src={gmail} alt="" />
                </span>
              </div>
              <label
                htmlFor=""
                className="form-label position-absolute d-inline-block bg-white m-0 px-1"
              >
                Email
              </label>
              {formik.touched.email && formik.errors.email ? (
                <div className="text-danger">{formik.errors.email}</div>
              ) : null}
            </div>
          </Col>
          <Col lg="12" className="my-3">
            <div className="position-relative labelInput">
              <div className="iconWithText position-relative">
                <input
                  type={formik.values.showPassword ? "text" : "password"}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="form-control "
                  placeholder="********"
                />
                <span className="icn position-absolute" style={{ left: "8px" }}>
                  <img src={pwd} alt="" />
                </span>
                <Button
                  onClick={() =>
                    formik.setFieldValue(
                      "showPassword",
                      !formik.values.showPassword
                    )
                  }
                  variant="transparent"
                  className="border-0 p-0 icn position-absolute"
                  style={{ right: "8px" }}
                >
                  {formik.values.showPassword ? (
                    <img src={visiblePass} alt="" />
                  ) : (
                    <img src={nonVisiblePass} alt="" />
                  )}
                </Button>
              </div>
              <label
                htmlFor=""
                className="form-label position-absolute d-inline-block bg-white m-0 px-1"
              >
                Password
              </label>
              {formik.touched.password && formik.errors.password ? (
                <div className="text-danger">{formik.errors.password}</div>
              ) : null}
            </div>
          </Col>
          <Col lg="12" className="">
            <div className="d-flex align-items-center justify-content-between gap-10">
              <div className="left d-flex align-items-center">
                <input
                  type="checkbox"
                  id="rememeberMe"
                  className="form-check me-2"
                />
                <label htmlFor="rememeberMe" className="form-label m-0">
                  Remember Me
                </label>
              </div>
              <div className="right">
                <Link to={generatePath(ROUTES.FORGOT_PASSWORD)} className="text-danger fw-sbold">
                  Forgot Password?
                </Link>
              </div>
            </div>
          </Col>
          {formik.status?.server && (
            <Col lg="12" className="my-3">
              <div className="text-danger">{formik.status.server}</div>
            </Col>
          )}
          <Col lg="12" className="my-3">
            <Button
              type="submit"
              className="d-flex align-items-center justify-content-center w-100 commonBtn"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Logging in..." : "LOGIN"}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Login;
